'use client';

import React from 'react';
import { AnimatedTitle } from '../../animated-title';

import type {
  Artwork,
  Nftcollection,
  Exhibition,
  Immersive,
  Installation,
  Physicalartwork,
  LandscapeChapter,
} from '@/types';
import { CatalogCard } from '../catalog-card';
import { artworkToCatalogItem } from '@/lib/services/catalog/artwork.service';
import { nftCollectionToCatalogItemSync } from '@/lib/services/catalog/nftcollection.service';
import { exhibitionToCatalogItem } from '@/lib/services/catalog/exhibitions.service';
import { immersiveToCatalogItem } from '@/lib/services/catalog/immersives.service';
import { installationToCatalogItem } from '@/lib/services/catalog/installations.service';
import { physicalToCatalogItem } from '@/lib/services/catalog/physicals.service';

interface LandscapeChapterProps {
  layout: LandscapeChapter;
}

export const Landscape_Chapter: React.FC<LandscapeChapterProps> = ({ layout }) => {
  const renderCatalogCard = (item: Artwork | Nftcollection | Exhibition | Immersive | Installation | Physicalartwork, relationTo: string) => {
    let res;
    switch (relationTo) {
      case 'artworks':
        res = artworkToCatalogItem(item as Artwork);
        return <CatalogCard artwork={res} onEnlarge={() => {}} />;
      case 'nftcollections':
        res = nftCollectionToCatalogItemSync(item as Nftcollection);
        return <CatalogCard artwork={res} onEnlarge={() => {}} />;
      case 'exhibitions':
        res = exhibitionToCatalogItem(item as Exhibition);
        return <CatalogCard artwork={res} onEnlarge={() => {}} />;
      case 'immersives':
        res = immersiveToCatalogItem(item as Immersive);
        return <CatalogCard artwork={res} onEnlarge={() => {}} />;
      case 'installations':
        res = installationToCatalogItem(item as Installation);
        return <CatalogCard artwork={res} onEnlarge={() => {}} />;
      case 'physicalartworks':
        res = physicalToCatalogItem(item as Physicalartwork);
        return <CatalogCard artwork={res} onEnlarge={() => {}} />;
      default:
        return null;
    }
  };

  return (
    <section className="w-full">
      <div className="p-[15px] rounded-md bg-white mb-[12px] flex flex-col justify-between relative pt-8">
        {layout.title ? (
          <div className="absolute top-[15px] left-[15px]">
            <AnimatedTitle>{layout.title}</AnimatedTitle>
          </div>
        ) : (
          ''
        )}
        {layout.titleRightTop ? (
          <div className="absolute top-[15px] right-[15px]">
            <AnimatedTitle marginClass="mb-0">{layout.titleRightTop}</AnimatedTitle>
          </div>
        ) : (
          ''
        )}

        {/* Content */}
        {layout.relatedItems?.map((relatedItemGroup, groupIndex) => (
          <div
            key={`group-${groupIndex}`}
            className={`my-4 grid gap-x-3 gap-y-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 ${
              relatedItemGroup.items?.length === 5
                ? 'xl:grid-cols-5'
                : relatedItemGroup.items?.length === 6
                  ? 'xl:grid-cols-6'
                  : relatedItemGroup.items?.length === 7
                    ? 'xl:grid-cols-7'
                    : relatedItemGroup.items?.length === 8
                      ? 'xl:grid-cols-8'
                      : relatedItemGroup.items?.length === 9
                        ? 'xl:grid-cols-9'
                        : relatedItemGroup.items?.length >= 10
                          ? 'xl:grid-cols-10'
                          : 'xl:grid-cols-5'
            }`}
          >
            {relatedItemGroup.items?.map((item, itemIndex) => {
              // Determine what type of item we're dealing with
              const relationTo = item.relationTo;
              const value = item.value;

              return (
                <div key={`item-${groupIndex}-${itemIndex}`} className="mb-16">
                  {/* Render based on relationTo type */}
                  {typeof value === 'object' && <div>{renderCatalogCard(value, relationTo)}</div>}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </section>
  );
};
